module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showLabel) ? _c('div', {
    class: ("articleLabel-container articleLabel-container--" + _vm.mainComponent)
  }, [(_vm.showShadow) ? _c('div', {
    class: (_vm.baseClasses + " showShadow")
  }, [_vm._v(_vm._s(_vm.articleType))]) : _vm._e(), _c('div', {
    class: (_vm.baseClasses + " animate__" + _vm.articleType)
  }, [_vm._v(_vm._s(_vm.articleType))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9e2064","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/common/SpeechBalloonLabel.vue
// module id = 960
// module chunks = 1 2 3 6 7 24